<div class="row">
  <div class="col-md-6">
    <app-form-group>
      <label>Select stowage</label>
      <app-multiselect [(ngModel)]="handling.stowages" [options]="handling.options" dataKey="stowageNumber"
                       [hideSelected]="true" [enableSelectAll]="true" [autoSelectOnlyOption]="true"
                       placement="top-end" title="Select stowage to discharge"></app-multiselect>
    </app-form-group>
  </div>
  @if (context.dangerousGoodsDeclaration.dangerousGoods.hasTanks) {
    <div class="col-md-6">
      <app-form-group>
        <label>Ship to ship</label>
        <app-yes-no required [(ngModel)]="handling.shipToShip"></app-yes-no>
      </app-form-group>
      @if (handling.hasInertTanks) {
        <app-form-group>
          <label>Tanks remain inert</label>
          <app-yes-no required [(ngModel)]="handling.keepInert"></app-yes-no>
        </app-form-group>
      }
    </div>
  }
</div>

<div class="row no-gutters mt-4 mb-2">
  <div class="col">
    @if (handling.prewashingRequired) {
      <div class="alert alert-warning show row align-items-center" role="alert">
        <div class="col-1 ps-2">
          <i class="fa fa-light fa-circle-exclamation" aria-hidden="true" style="font-size: xxx-large"></i>
        </div>
        <div class="col-11">
          Please make sure the handling washing is applied after discharging the load.
        </div>
      </div>
    }
  </div>
</div>

@if (handling.bulk?.length > 0) {
  <div class="row g-0 bg-secondary text-light py-2">
    <div class="col"><span class="ps-2">Bulk</span></div>
    <div class="col-auto ps-2" style="width: 2rem"></div>
  </div>
  @for (stowage of handling.bulk; track stowageById(stowage); let index = $index) {
    <div>
      <div class="row g-0 my-2">
        <div class="col">
          <div class="row g-0">
            <div class="col-auto" style="width: 11rem">
              <input [ngModel]="stowage.stowageNumber" class="form-control bg-transparent border-0" [disabled]="true">
            </div>
            @if (stowage.availableBulk) {
              <div class="col-auto ps-3 pe-2">
                <app-yes-no required [(ngModel)]="stowage.emptied" (ngModelChange)="onEmptyChanged(stowage)"
                            [formatter]="emptyFormatter" [id]="'dischargeTillEmpty-' + index"></app-yes-no>
              </div>
            }
            @if (stowage.availableBulk && stowage.emptied === false) {
              <div class="col-auto" style="width: 11rem">
                <input required [(ngModel)]="stowage.amount" class="form-control" placeholder="Choose amount"
                       appDecimalNumber [maxDecimals]="3">
              </div>
            }
            @if (stowage.availableBulk && stowage.emptied) {
              <div class="col-auto" style="width: 11rem">
                <input [disabled]="true" [ngModel]="stowage.availableBulk"
                       class="form-control" placeholder="Choose amount" appDecimalNumber [maxDecimals]="3">
              </div>
            }
            @if (stowage.availableBulk) {
              <div class="col-auto">
                <div class="form-control border-0 bg-transparent"> TNE</div>
              </div>
            }
            @if (stowage.needsPrewashing && stowage.emptied) {
              <div class="col-auto">
                <div class="form-control border-0 bg-transparent"> (Tank requires Washing, when fully discharged!)</div>
              </div>
            }
          </div>
        </div>
        <div class="col-auto text-end" style="min-width: 2rem">
          <button title="Delete stowage" (click)="deleteStowage(stowage)"
                  class="btn" type="button" tabindex="-1"><span class="fa fa-trash text-secondary"></span>
          </button>
        </div>
      </div>
    </div>
  }
}

<div class="row g-0 mt-4 mb-2">
  <div class="col">
    <span class="dropdown">
      @if (!handling.containersOnly) {
        <button type="button" class="btn btn-info my-2 dropdown-toggle" style="width: 10rem"
                [disabled]="handling.availableGoods.length===0" data-bs-toggle="dropdown">Discharge good</button>
      }
      <span class="dropdown-menu">
        @for (good of handling.availableGoods; track good) {
          <button type="button" class="dropdown-item"
                  (click)="dischargeGood(good)" data-bs-toggle="collapse">{{ good['uniqueGoodName'] | titlecase }}
          </button>
        }
      </span>
    </span>
  </div>
</div>

